module.exports = __webpack_public_path__ + "999420c203790db6466d743f37e274ff.svg";